import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { VERSION_FIELD_DESCRIPTOR } from './_versionField.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { SIZE_GRID } from '../types/size-grid.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for SizeGrid (Grade de tamanhos).
 * Stored in 'org/{orgId}/size-grid'.
 * Occurrences live in the SizeOccurrence subcollection (spec 0032 §4 / request 0096).
 */
export const sizeGridDescriptor = {
    name: SIZE_GRID,
    label: 'Grade de tamanhos',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/size-grid',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Catálogo de grades de tamanho (código + descrição); ocorrências na subcoleção',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        // NoCache: entidade versionada (spec 0045) — getById em cache devolve versão velha.
        cache: CacheStrategy.NoCache,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique size grid identifier',
        },
        {
            name: 'code',
            example: 'GU',
            label: 'Código',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.CODE,
            description: 'Short grid code (e.g. CALC-M-BR, BEBE)',
        },
        {
            name: 'description',
            example: 'Grade Única',
            label: 'Descrição',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Grid display name (e.g. Calçado Masculino BR)',
        },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
        VERSION_FIELD_DESCRIPTOR,
    ],
    foreignKeys: [
        ...AUDIT_FOREIGN_KEYS,
        {
            fieldName: 'id',
            targetEntity: 'SizeOccurrence',
            relationship: 'one-to-many',
            description: 'Tamanhos da grade',
        },
    ],
};
//# sourceMappingURL=size-grid.descriptor.js.map